import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form, Button as BButton, Button as BsButton } from "react-bootstrap";
import Select from "react-select";
import StateField from "../components/states/StatesField";

export default function MultiTrainingFrom({
  altTrainerForm,
  setSubFormData,
  increaseAlternative,
  decreaseAlternative,
  handleInputChange,
  allDropDowns,
  noBtns,
  type,
  fieldsRequired = true,
  countriesList,
  setTrainingPhoneValidations,
  setValidateField = "",
  validated,
  sectionId = "",
  sectionName="",
}) {

  const [phone, setPhone] = useState("");
  const [phoneExt, setPhoneExt] = useState("");

  const [phoneType, setPhoneType] = useState("");
  const [main, setMain] = useState(0);
  const [selectedCountry, setSelectedCountry] = React.useState({});
  const [phoneValidations, setPhoneValidations] = React.useState({});

  // const HandleSubForm = () => {
  //   let mySubFormData = [...altTrainerForm];
  //   mySubFormData[formIndex] = {
  //     phone_number: phone,
  //     ext: phoneExt,
  //     phone_type_id: phoneType,
  //     main: main,
  //   };
  // };

  const [phoneErrors, setPhoneErrors] = useState([]);

  const updateFieldChanged = (e, index, name) => {

    let newPhoneErrors = [...phoneErrors];

    if (e.target.name === 'alternative_phone') {
      e.target.value = e.target.value.replace(/[^0-9]/g, "").trim();
      e.target.value = e.target.value.slice(0, 10);
      
      if (e.target.value.trim().length < 10) {
        newPhoneErrors[index] = true;
      } else {
        newPhoneErrors[index] = false;
      }
    }

    let newArr = [...altTrainerForm];
    newArr[index][name] = e.target.value;
    
    setSubFormData(newArr);
    setPhoneErrors(newPhoneErrors);
  };

  // handle select change
  const handleSelectChange = (data, key, index) => {
    let newArr = [...altTrainerForm];
    newArr[index][key] = data.value;
    setSubFormData(newArr);

    setSelectedCountry((old) => ({
      ...old,
      [key]: {
        label: data?.label,
        value: data?.value,
      },
    }));
  };

  useEffect(() => {
    if (countriesList) {
      if (altTrainerForm[0]?.account_alternate_traning_location_country) {
        const country = countriesList.find(
          (country) =>
            country.value ==
            parseInt(
              altTrainerForm[0]?.account_alternate_traning_location_country
            )
        );
        setSelectedCountry((old) => ({
          ...old,
          account_alternate_traning_location_country: {
            label: country?.label,
            value: country?.value,
          },
        }));
      } else {
        setSelectedCountry((old) => ({
          ...old,
          account_alternate_traning_location_country: {
            label: countriesList[230]?.label,
            value: countriesList[230]?.value,
          },
        }));
      }
    }
  }, [countriesList, altTrainerForm]);

  return (
    <>
      {altTrainerForm.map((singleForm, index) => (
        <div key={index} id={`${sectionId}_${index}`}>
          <div
            className="row mb-4 "
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="col-4">
              <div className="d-flex mb-2" style={{ alignItems: "center" }}>
                <Form.Label>Company Name</Form.Label>
                {type != "trainingEdit" && (
                  <>
                    <button
                      onClick={increaseAlternative}
                      className="btn mx-2 btn-sm btn-primary "
                      type="button"
                      name={`${sectionName}_plus`}
                    >
                      +
                    </button>
                    <button
                      onClick={decreaseAlternative}
                      className="btn mx-2 btn-sm btn-danger "
                      type="button"
                      name={`${sectionName}_minus`}
                    >
                      -
                    </button>
                  </>
                )}
              </div>

              <Form.Group className={"col"}>
                <Form.Control
                  type="text"
                  name="account_alternate_traning_location_company_name"
                  value={
                    singleForm.account_alternate_traning_location_company_name
                  }
                  onChange={(e) => updateFieldChanged(e, index, 'account_alternate_traning_location_company_name')}
                />
              </Form.Group>
            </div>

            <div className="col-8 row">
              <Form.Group className={"col-md-4"}>
                <div className="d-flex mb-2" style={{ alignItems: "center" }}>
                  <Form.Label>Phone </Form.Label>
                  {noBtns && (
                    <>
                      <button
                        onClick={increaseAlternative}
                        type="button"
                        className="btn mx-2 btn-sm btn-primary "
                      >
                        +
                      </button>
                      <button
                        onClick={decreaseAlternative}
                        type="button"
                        className="btn mx-2 btn-sm btn-danger "
                      >
                        -
                      </button>
                    </>
                  )}
                </div>

                <Form.Control
                  type="text"
                  name="alternative_phone"
                  value={singleForm.alternative_phone}
                  onChange={(e) => updateFieldChanged(e, index, 'alternative_phone')}
                  // required
                  minLength={10}
                  maxLength={10}
                  className={phoneErrors[index] ? "phone-invalid-input" : ""}
                />
                {
                  phoneErrors[index] && (
                    <div className="phone-invalid">
                      Please Enter Exact 10 digits.
                    </div>
                  )
                }
              </Form.Group>

              <Form.Group className={"col-md-4"}>
                <div className="mb-2">
                  <Form.Label>Ext</Form.Label>
                </div>

                <Form.Control
                  type="number"
                  name="alternative_ext"
                  onChange={(e) => updateFieldChanged(e, index, 'alternative_ext')}
                  value={singleForm.alternative_ext}
                />
              </Form.Group>

              {/* <Form.Group className={"col"}>
                <Form.Label>Phone Type</Form.Label>
                <Form.Select
                  className={""}
                  name="phone_type_id"
                  onChange={updateFieldChanged(index)}
                  defaultValue={singleForm.phone_type_id}
                >
                  <option defaultValue="0">--Select One--</option>
                  {allDropDowns?.phoneType &&
                    allDropDowns?.phoneType.map((PT, index) => (
                      <option defaultValue={PT.dropdown_phone_type_id} key={index}>
                        {PT.dropdown_phone_type_name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group> */}

              {/* <Form.Group className={"col d-block"}>
                <b className={""}>Main</b>
                <div className="">
                  <FormControlLabel
                    className={""}
                    label=""
                    value={true}
                    name="main"
                    onChange={updateFieldChanged(index)}
                    control={<Switch color="primary" size="medium" />}
                  />
                </div>
              </Form.Group> */}
            </div>
          </div>

          <div className="row my-4">
            <Form.Group className={"col relative"}>
              <Form.Label>Country</Form.Label>
              <Select
                value={
                  selectedCountry?.account_alternate_traning_location_country
                }
                options={countriesList}
                onChange={(data) => {
                  handleSelectChange(
                    data,
                    "account_alternate_traning_location_country",
                    index
                  );
                }}
              />
              <Form.Control.Feedback type="invalid">
                Please Enter Country.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className={"col"}>
              <Form.Label>Address* </Form.Label>
              <Form.Control
                type="text"
                required
                name="account_alternate_traning_location_address1"
                value={singleForm.account_alternate_traning_location_address1}
                onChange={(e) => updateFieldChanged(e, index, 'account_alternate_traning_location_address1')}
              />
              <Form.Control.Feedback type="invalid">
                Please Enter Address.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className={"col"}>
              <Form.Label>Address 2</Form.Label>
              <Form.Control
                type="text"
                name="account_alternate_traning_location_address2"
                value={singleForm.account_alternate_traning_location_address2}
                onChange={(e) => updateFieldChanged(e, index, 'account_alternate_traning_location_address2')}
              />
            </Form.Group>

            <Form.Group className={"col"}>
              <Form.Label>City* </Form.Label>
              <Form.Control
                type="text"
                required
                name="account_alternate_traning_location_city"
                value={singleForm?.account_alternate_traning_location_city}
                onChange={(e) => updateFieldChanged(e, index, 'account_alternate_traning_location_city')}
              />
              <Form.Control.Feedback type="invalid">
                Please Enter City.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className={"col"}>
              <Form.Label>State* </Form.Label>

              <StateField
                setFormData={setSubFormData}
                valueKey="account_alternate_traning_location_state"
                selectedCountry={
                  selectedCountry?.account_alternate_traning_location_country
                    ?.value
                }
                validated={validated}
                required={fieldsRequired ? true : false}
                type="array"
                index={index}
                altTrainerForm={altTrainerForm}
                stateSelectedValue={
                  singleForm.account_alternate_traning_location_state
                }
              />
              <Form.Control.Feedback type="invalid">
                Please Enter State.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className={"col"}>
              <Form.Label>Zip code* </Form.Label>
              <Form.Control
                type="number"
                name="account_alternate_traning_location_zipcode"
                defaultValue={
                  singleForm.account_alternate_traning_location_zipcode
                }
                required
                onChange={(e) => updateFieldChanged(e, index, 'account_alternate_traning_location_zipcode')}
              />
              <Form.Control.Feedback type="invalid">
                Please Enter Zip code.
              </Form.Control.Feedback>
            </Form.Group>
          </div>
        </div>
      ))}
    </>
  );
}
